<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('blogs')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Blog</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <b-form-group label="Title">
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="blog_data.title"
          >
          </base-input>
        </b-form-group>
        <b-form-group
          label="Blog image (max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div v-if="image">
            <p class="mt-2">Image Preview</p>

            <img v-if="image" :src="cropperImg" ref="cover" />
            <div class="flex cursor-pointer items-center my-2" v-if="image">
              <base-button type="danger" class="px-8" @click="handleRemove">
                Remove image
              </base-button>
            </div>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>

          <div class="mt-3 mb-4">
            <p class="mb-2">Uploaded Image</p>
            <img
              class="w-1/2"
              :src="$imageURL + '/' + selectedBlog.image"
              alt="uploaded-image"
            />
          </div>
        </b-form-group>
        <b-form-group label="Description">
          <quill-editor
            v-model="blog_data.html"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>

        <!-- <b-form-group id="input-group-3" label="Tags:" label-for="input-3">
          <b-form-select id="input-3" v-model="selectedtag" required>
            <b-form-select-option :value="null" disabled
              >-- Please select an Tags --</b-form-select-option
            >
            <b-form-select-option
              v-for="(tag, indexOpt) in tags"
              :value="tag._id"
              :key="indexOpt"
              >{{ tag.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->

        <!-- <b-form-group label="Page:">
          <b-form-select
            v-model="blog_data.pageCategory.route"
            required
            @change="gettagsbycategory(blog_data.pageCategory)"
          >
            <b-form-select-option :value="null" disabled
              >-- Please select a Page --</b-form-select-option
            >
            <b-form-select-option
              v-for="pageCategory in pageCategories"
              :value="pageCategory.route"
              :key="pageCategory._id"
              >{{ pageCategory.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->
        <div class="mb-2">
          <b-form-group label="Tags:">
            <div class="md:flex justify-between items-center">
              <b-form-select v-model="blog_data.tags[0]" required class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                >
              </b-form-select>
              <b-form-select v-model="blog_data.tags[1]" class="mr-4">
                <b-form-select-option :value="null" disabled
                  >Select {{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                >
              </b-form-select>
              <!-- <b-form-select v-model="blog_data.tags[2]" class="mr-4">
                <b-form-select-option :value="null" disabled>
                  Select {{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              > -->
              <multiselect
                class="mr-4"
                v-model="selectedUsers"
                :options="filter3"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="From Whom"
                track-by="_id"
                label="name"
                :preselect-first="false"
              >
              </multiselect>
              <b-form-select v-model="selectedAuthor" class="mr-4">
                <b-form-select-option :value="null"
                  >{{ author.length !== 0 ? "Select Author" : "No Author" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="author in filter4"
                  :value="author._id"
                  :key="author._id"
                  >{{ author.name }}</b-form-select-option
                >
              </b-form-select>

              <b-form-select v-model="selectedDoctor" class="">
                <b-form-select-option :value="null"
                  >{{
                    doctor.length !== 0 ? "Medically reviewed by" : "No Doctor"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="doctor in filter5"
                  :value="doctor._id"
                  :key="doctor._id"
                  >{{ doctor.name }}</b-form-select-option
                >
              </b-form-select>
            </div>
          </b-form-group>
        </div>
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-1" v-model="isFeatured">
            <p>
              <strong>
                <p class="col-blk">Click here to feature this blog.</p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <div class="mb-2 w-1/3">
          <div>
            <label class="mr-4" for="date">Date:</label>
          </div>
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Pick a date"
            :default-value="new Date()"
            format="dd-MM-yyyy"
            name="date"
            required
          >
          </el-date-picker>
        </div>
        <!-- <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
          >
          </multiselect>
        </div> -->
        <div class="mb-2 pad">
          <b-form-radio-group
            v-model="isActive"
            :options="isActiveOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
          ></b-form-radio-group>
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-2" v-model="onlyRegistered">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to limit access to the blog.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <!-- <div class="mb-2">
          <b-form-checkbox id="checkbox-3" v-model="isSelected">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on campaign.
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div> -->
        <div class="mb-2">
          <b-form-checkbox id="checkbox-4" v-model="isSelectedCancer">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Cancer page
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2">
          <b-form-checkbox id="checkbox-5" v-model="isSelectedPalliative">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on palliative page
                </p></strong
              >
            </p></b-form-checkbox
          >
          <b-form-checkbox id="checkbox-6" v-model="isSelectedDementia">
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Dementia page
                </p></strong
              >
            </p></b-form-checkbox
          >
          <b-form-checkbox
            id="checkbox-7"
            v-model="isSelectedNeurodegenerative"
          >
            <p>
              <strong>
                <p class="col-blk">
                  Select this option to show this blog on Neurological Disorders
                  page
                </p></strong
              >
            </p></b-form-checkbox
          >
        </div>
        <div class="mb-2 w-1/3">
          <label for="campaign">Campaigns:</label>
          <multiselect
            v-model="selectedCampaigns"
            :options="getCampaignOptions()"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Campaign"
            track-by="value"
            label="label"
            :preselect-first="false"
          ></multiselect>
        </div>
        <div class="mb-2 w-1/3">
          <label for="membership">Membership:</label>
          <multiselect
            name="membership"
            v-model="selectedMembership"
            :options="membershipFilter"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Memberships"
            track-by="name"
            label="name"
            :preselect-first="false"
            :disabled="!onlyRegistered ? true : false"
          >
          </multiselect>
        </div>

        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="metaKeyword"
            >
            </base-input>
          </div>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { DatePicker } from "element-ui";

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    Cropper,
    quillEditor,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      isActiveOptions: [
        { item: true, name: "Active" },
        { item: false, name: "In-Active" },
      ],
      isActive: true,
      image: "",
      coverImage: "",
      cropperImg: "",
      filter1: [],
      filter2: [],
      filter3: [],
      filter4: [],
      filter5: [],
      membershipFilter: [],
      selectedCampaigns: [],
      campaignOptions: [],
      selectedMembership: null,
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      pageData: {},
      blog_data: {},
      selectedAuthor: null,
      selectedDoctor: null,
      selectedUsers: null,
      selectedUsersId: [],
      onlyRegistered: false,
      isSelectedCancer: false,
      isSelectedPalliative: false,
      isSelectedDementia: false,
      isSelectedNeurodegenerative: false,
      isFeatured: false,
      date: null,
      imageErr: false,
      msg: {
        name: "",
        image: "",
      },
      metaTitle: "",
      metaKeyword: "",
      metaDesc: "",
      metaCanonicalTag: "",
    };
  },
  computed: {
    ...mapState("cms", {
      selectedBlog: "selectedBlog",
      filtertags: "filtertags",
      filters: "filters",
    }),
    ...mapState("cmsAuthor", {
      author: "author",
    }),
    ...mapState("doctor", {
      doctor: "doctor",
    }),
    ...mapState("subscribe", {
      get_all_membership: "get_all_membership",
    }),
    ...mapState("campaignPageBanner", { campaignHome: "campaignHome" }),
    campaignHome() {
      return this.$store.state.campaignPageBanner.campaignHome || {};
    },
  },
  watch: {
    pageData(val) {
      this.blog_data = { ...val };
      this.metaCanonicalTag = this.blog_data.metaCanonicalTag;
      this.metaDesc = this.blog_data.metaDesc;
      this.metaKeyword = this.blog_data.metaKeyword;
      this.metaTitle = this.blog_data.metaTitle;
      // if(this.blog_data?.authors?[0]._id)
      // console.log(this.blog_data.authors === null);
      // console.log(this.blog_data);
      let selectedUserData =
        this.blog_data.tags && this.blog_data.tags.slice(2);
      // this.selectedUsers = this.filter3.filter((tag) => {
      //   if(tag._id === selectedUserData)
      // });
      if (selectedUserData.length > 0) {
        this.selectedUsers = this.filter3.filter((tag) =>
          selectedUserData.includes(tag._id)
        );
      }
      // console.log(this.selectedUsers);
      if (
        // this.blog_data.authors !== null ||
        // this.blog_data.authors.length !== 0
        Array.isArray(this.blog_data.authors) ||
        (this.blog_data.authors && this.blog_data.authors.length !== 0)
      ) {
        // this.blog_data.authors.push({ _id: null });
        this.selectedAuthor = this.blog_data.authors[0]._id;
      } else {
        this.selectedAuthor = null;
      }

      if (
        Array.isArray(this.blog_data.doctors) ||
        (this.blog_data.doctors && this.blog_data.doctors.length !== 0)
      ) {
        this.selectedDoctor = this.blog_data.doctors[0]._id;
      } else {
        this.selectedDoctor = null;
      }
    },

    membershipFilter() {
      if (this.blog_data.memberships && this.blog_data.memberships.length > 0) {
        this.selectedMembership = this.membershipFilter.filter((membership) => {
          let data = this.blog_data.memberships.find(
            (member) => member._id === membership._id
          );
          // return this.blog_data.memberships.includes(membership._id);
          return data;
        });
        // console.log(this.selectedMembership);
      }
    },

    selectedUsers(val) {
      this.selectedUsersId = val.map((tag) => tag._id);
    },
  },
  methods: {
    getCampaignOptions() {
      return this.campaignHome && this.campaignHome.result
        ? this.campaignHome.result.map((campaign) => ({
            label: campaign.heading,
            value: campaign._id,
          }))
        : [];
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    async gettagsbycategory() {
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredAPIData = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        {
          id: this.categoryId,
        }
      );
      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);

      let filteredAuthorAPIData = await this.$store.dispatch(
        "cmsAuthor/getAuthor"
      );
      this.filter4 = this.author.result;

      let filteredDoctorAPIData = await this.$store.dispatch(
        "doctor/getDoctor"
      );
      this.filter5 = this.doctor.result;
      let filteredMembershipAPIData = await this.$store.dispatch(
        "subscribe/GetAllMembership"
      );
      this.membershipFilter = this.get_all_membership.filter((membership) => {
        if (
          membership.name.toLowerCase() !== "visitor" &&
          membership.name.toLowerCase() !== "registered"
        ) {
          return true;
        }
        return false;
      });
      // console.log(this.membershipFilter);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    // async onSubmit() {
    //   if (!this.onlyRegistered) {
    //     this.selectedMembership = null;
    //   }

    //   let payload = {};

    //   this.Ctags.push(
    //     this.blog_data.tags[0],
    //     this.blog_data.tags[1],
    //     ...this.selectedUsersId
    //   );

    //   payload._id = this.blog_data._id;
    //   payload.title = this.blog_data.title;
    //   payload.media = this.coverImage;
    //   payload.html = this.blog_data.html;
    //   payload.pageCategory = this.blog_data.pageCategory;
    //   payload.tags = JSON.stringify(_.uniq(this.Ctags));
    //   payload.authors = JSON.stringify(this.selectedAuthor);
    //   payload.doctors = JSON.stringify(this.selectedDoctor);
    //   payload.memberships = JSON.stringify(this.selectedMembership);
    //   payload.isFeatured = this.isFeatured;
    //   payload.isSelected = this.isSelected;
    //   payload.isSelectedCancer = this.isSelectedCancer;
    //   payload.isSelectedPalliative = this.isSelectedPalliative;

    //   if (this.blog_data.metaKeyword != this.metaKeyword) {
    //     payload.metaKeyword = this.metaKeyword;
    //   }
    //   if (this.blog_data.metaCanonicalTag != this.metaCanonicalTag) {
    //     payload.metaCanonicalTag = this.metaCanonicalTag;
    //   }
    //   if (this.blog_data.metaDesc != this.metaDesc) {
    //     payload.metaDesc = this.metaDesc;
    //   }
    //   if (this.blog_data.metaTitle != this.metaTitle) {
    //     payload.metaTitle = this.metaTitle;
    //   }

    //   if (this.selectedMembership !== null) {
    //     payload.onlySubscribed = true;
    //     payload.onlyRegistered = true;
    //   } else {
    //     payload.onlyRegistered = this.onlyRegistered;
    //     payload.onlySubscribed = false;
    //   }

    //   payload.isActive = this.isActive;
    //   payload.date = this.date;

    //   // Loading indicator
    //   let loader = this.$loading();
    //   try {
    //     const editData = await this.$store.dispatch("cms/editPage", payload);
    //     if (editData.code == 200) {
    //       this.$emit("editchange");
    //       this.$swal.fire({
    //         text: "Blog successfully edited",
    //         icon: "success",
    //         confirmButtonText: "Okay",
    //         confirmButtonColor: "#830c81",
    //         showCancelButton: false,
    //       });
    //       loader.close();
    //     }
    //   } catch (error) {
    //     if (error) {
    //       loader.close();
    //     }
    //   }
    // },

    async onSubmit() {
      if (!this.onlyRegistered) {
        this.selectedMembership = null;
      }
      let FormData = require("form-data");
      let data = new FormData();
      this.Ctags.push(
        this.blog_data.tags[0],
        this.blog_data.tags[1],
        ...this.selectedUsersId
      );
      data.append("_id", this.blog_data._id);
      data.append("title", this.blog_data.title);
      data.append("media", this.coverImage);
      data.append("html", this.blog_data.html);
      data.append("pageCategory", this.blog_data.pageCategory);
      data.append("tags", JSON.stringify(_.uniq(this.Ctags)));
      data.append("authors", JSON.stringify(this.selectedAuthor));
      data.append("doctors", JSON.stringify(this.selectedDoctor));
      data.append("memberships", JSON.stringify(this.selectedMembership));
      data.append(
        "selectedCampaigns",
        this.selectedCampaigns.map((campaign) => campaign.value)
      );
      data.append("isFeatured", this.isFeatured);
      data.append("isSelected", this.isSelected === true);
      data.append("isSelectedCancer", this.isSelectedCancer === true);
      data.append("isSelectedPalliative", this.isSelectedPalliative === true);
      data.append("isSelectedDementia", this.isSelectedDementia === true);
      data.append(
        "isSelectedNeurodegenerative",
        this.isSelectedNeurodegenerative === true
      );
      if (this.blog_data.metaKeyword != this.metaKeyword) {
        data.append("metaKeyword", this.metaKeyword);
      }
      if (this.blog_data.metaCanonicalTag != this.metaCanonicalTag) {
        data.append("metaCanonicalTag", this.metaCanonicalTag);
      }
      if (this.blog_data.metaDesc != this.metaDesc) {
        data.append("metaDesc", this.metaDesc);
      }
      if (this.blog_data.metaTitle != this.metaTitle) {
        data.append("metaTitle", this.metaTitle);
      }
      if (this.selectedMembership !== null) {
        data.append("onlySubscribed", true);
        data.append("onlyRegistered", true);
      } else {
        data.append("onlyRegistered", this.onlyRegistered);
        data.append("onlySubscribed", false);
      }
      data.append("isActive", this.isActive);
      data.append("date", this.date);
      // console.log();
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch("cms/editPage", data);
        if (editData.code == 200) {
          this.$emit("editchange");
          // this.$router.push({
          //   name: "blogs",
          // });
          // const pageParam = this.$route.query.page;
          // if (pageParam) {
          //   // console.log("page-param...", pageParam);
          //   // this.currentPage = parseInt(pageParam);
          //   this.$router.push({
          //     name: "blogs",
          //     query: { page: parseInt(pageParam) },
          //   });
          // }
          this.$swal.fire({
            text: "Blog successfully edited",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedBlog;
      // console.log(this.selectedBlog);
      this.onlyRegistered = this.selectedBlog.onlyRegistered;
      this.isFeatured = this.selectedBlog.isFeatured;
      this.date = this.selectedBlog.date || null;
      this.isActive = this.selectedBlog.isActive
        ? this.selectedBlog.isActive
        : false;
      // this.isSelected = this.selectedBlog.isSelected;
      this.isSelectedCancer = this.selectedBlog.isSelectedCancer;
      this.isSelectedPalliative = this.selectedBlog.isSelectedPalliative;
      this.isSelectedDementia = this.selectedBlog.isSelectedDementia;
      this.isSelectedNeurodegenerative =
        this.selectedBlog.isSelectedNeurodegenerative;
      // this.selectedCampaigns = this.selectedBlog.selectedCampaigns;

      if (this.selectedBlog.selectedCampaigns && this.campaignHome.result) {
        this.selectedCampaigns = this.selectedBlog.selectedCampaigns.map(
          (campaignId) => {
            const campaign = this.campaignHome.result.find(
              (c) => c._id === campaignId
            );
            return campaign
              ? { label: campaign.heading, value: campaign._id }
              : null;
          }
        );
        // .filter(Boolean);
      }
      // else {
      //   this.selectedCampaigns = [];
      // }
      // console.log(this.selectedBlog.isActive);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$emit("editchange");
    },
  },
  mounted() {
    this.init();
    this.gettagsbycategory();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
